const TEXT = {
    LOGIN_CONTENT_TEXT_1:"登录",
    LOGIN_CONTENT_TEXT_2:"手机号",
    LOGIN_CONTENT_TEXT_3:"输入手机号或用户名",
    LOGIN_CONTENT_TEXT_4:"密码",
    LOGIN_CONTENT_TEXT_5:"请输入密码",
    LOGIN_CONTENT_TEXT_6:"登录"
};
export {
	TEXT
}



// WEBPACK FOOTER //
// ./src/config/page/cn/login/index.js